<template>
  <div @click="$emit('close')" class="absolute full panel-closer bg-black-transp cursor-pointer">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="postcss">
.bg-black-transp {
  background-color: rgba(0, 0, 0, 0.76);
}
.panel-closer{
  z-index: 1;
}
</style>